<template>
    <edit-resource
        v-if="form"
        :title="title"
        :form="form"
        translatable
        @close="$emit('close')"
        @submit="saveReason"
        custom-class="w-620"
    >
        <div class="max-w-600">
            <simple-input :staticId="'vacancyReasonInput'" v-model="form.title[selectedLocale]"/>
        </div>
    </edit-resource>
</template>

<script>
import EditResource from './EditResource.vue';
import Form from '../../etc/forms/Form';
import * as jobReasonService from '../../services/JobReasonService';
import { normalizeJson } from '../../../shared/helpers';
import SimpleInput from '../forms/Input.vue';
import JobReason from "../../models/JobReason";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';

function getFields () {
    return [
        { name: 'title', value: {} },
    ];
}

export default {
    components: {
        EditResource,
        SimpleInput,
    },
    props: {
        reason: JobReason,
    },
    data: function () {
        return {
            form: null,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'selectedLocale']),
        languages() {
            return this.currentCompany.jobsite.active_languages;
        },
        title () {
            return this.$t(this.reason ? 'general.edit_subject' : 'general.add_subject', { subject: this.$t('settings.reject_reasons.single') })
        }
    },
    methods: {
        generateForm () {
            let fields = getFields();

            if (this.reason) {
                fields.forEach((field, index) => {
                    fields[index].value = JSON.parse(JSON.stringify(this.reason[field.name]));
                });
            }

            return new Form(fields);
        },
        async saveReason () {
            if (this.reason && typeof this.reason.id !== 'string') {
                await this.updateReason();
            } else {
                await this.createReason();
            }

            this.$emit('close');
        },
        updateReason () {
            return this.form.submit(data => {
                data = this.formatBeforeSave(data);
                return jobReasonService.update(this.reason.id, data);
            }).then(result => {
                return useRepo(JobReason).save(normalizeJson(result));
            });
        },
        createReason () {
            return this.form.submit(data => {
                data = this.formatBeforeSave(data);
                return jobReasonService.store(data);
            }).then(result => {
                let jobReasons = useRepo(JobReason)
                    .where('order', value => value >= result.attributes.order)
                    .get()
                    .map(reason => ({
                        id: reason.id,
                        order: reason.order++,
                    }));

                useRepo(JobReason).save(jobReasons);

                return result;
            }).then(result => {
                return useRepo(JobReason).save(normalizeJson(result));
            });
        },
        formatBeforeSave (input) {
            let reason = this.reason
            let body = {
                data: { attributes: {}},
            };

            reason.title = input.title

            body.data.attributes = {...reason};

            return body;
        }
    },
    mounted() {
        this.form = this.generateForm()
    }
}
</script>
